import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import customerStoreModule from './customerStoreModule'
import subscribeStoreModule from './subscribeStoreModule'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    'app-customer':customerStoreModule,
    'app-dashboard': subscribeStoreModule,
  },
  strict: process.env.DEV,
})
